import { render, staticRenderFns } from "./signBankProtocolNobl.vue?vue&type=template&id=6db30644&scoped=true"
import script from "./signBankProtocolNobl.vue?vue&type=script&lang=js"
export * from "./signBankProtocolNobl.vue?vue&type=script&lang=js"
import style0 from "./signBankProtocolNobl.vue?vue&type=style&index=0&id=6db30644&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db30644",
  null
  
)

export default component.exports